// extracted by mini-css-extract-plugin
export var askAiIcon = "_lz-9";
export var container = "_lz-0";
export var groupSeparator = "_lz-a";
export var highlight = "_lz-4";
export var resultIcon = "_lz-5";
export var resultItem = "_lz-7";
export var resultSubtitle = "_lz-3";
export var resultTitle = "_lz-2";
export var resultsList = "_lz-1";
export var searchGroup = "_lz-6";
export var selected = "_lz-8";